import axios from "axios";
export const cart = {
  state: {
    products: [],
    product: null,
    cart: [],
    newId: "",
    notification: [],
  },
  getters: {
    getCartTotalPrice(state) {
      if (state.cart.length > 0) {
        return state.cart
          .map((el) => el.product.price * el.quantity)
          .reduce((a, c) => a + c);
      }
    },
  },
  mutations: {
    getProducts(state) {
      state.products;
      axios
        .get("http://localhost:3000/drugs")
        .then((response) => [(state.products = response.data)]);
    },
    getSpeceficProduct(state, product) {
      state.product = product;
    },
    addToCart(state, { product, quantity }) {
      let productInCart = state.cart.find((item) => {
        return item.product.id == product.id;
      });
      if (productInCart) {
        ++productInCart.quantity;
        // let spcId = null;
        // axios
        //   .get(
        //     `http://localhost:3000/cart?product.id=${productInCart.product.id}`
        //   )
        //   .then((response) => (spcId = response.data[0].id));
        // axios.put(`http://localhost:3000/drugs/${spcId}`, {
        //   product: state.product,
        //   quantity: ++state.quantity,
        // });
      } else {
        state.cart.push({ product, quantity });
        axios.post("http://localhost:3000/cart", {
          product: product,
          quantity: quantity,
        });
      }
      state.notification.push({
        id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
      });
      setTimeout(() => {
        state.notification.shift();
        // state.notification = [];
      }, 3000);
    },
    getCartItems(state) {
      axios.get("http://localhost:3000/cart").then((response) => {
        state.cart = response.data;
      });
    },
    removeItemFromCart(state, product) {
      state.cart = state.cart.filter((item) => {
        return item.product.id !== product.id;
      });
      axios
        .get(`http://localhost:3000/cart?product.id=${product.id}`)
        .then((response) => {
          axios.delete(`http://localhost:3000/cart/${response.data[0].id}`);
        });
    },
    async removeAllItemsFromCart(state) {
      axios.get("http://localhost:3000/cart").then((res) =>
        res.data.forEach((el) => {
          axios.delete(`http://localhost:3000/cart/${el.id}`);
        })
      );
      state.cart = [];
    },
    deleteSnack(state, id) {
      // console.log(state.notification[id]);
      state.notification = state.notification.filter((el) => {
        return el.id !== id.id;
        // console.log(el.id, id.id);
      });
      // console.log(id.id);
      // console.log(state.notification);
    },
  },
  actions: {
    A_getProducts({ commit }) {
      commit("getProducts");
    },
    A_getSpeceficProduct({ commit }, id) {
      axios.get(`http://localhost:3000/drugs/${id}`).then((response) => {
        commit("getSpeceficProduct", response.data);
      });
    },
    A_addToCart({ commit }, { product, quantity }) {
      commit("addToCart", { product, quantity });
    },
    A_getCartItems({ commit }) {
      commit("getCartItems");
    },
    A_removeItemFromCart({ commit }, product) {
      commit("removeItemFromCart", product);
    },
    A_removeAllItemsFromCart({ commit }) {
      commit("removeAllItemsFromCart");
    },
    A_deleteSnack({ commit }, id) {
      commit("deleteSnack", id);
    },
  },
};
